import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { LanguageService } from '@app/i18n';

export const apiLanguageInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req.clone({ setHeaders: { 'Accept-Language': inject(LanguageService).get() } }));
};
